import { CSSProperties } from 'react'

import { AppBar } from '@interco/inter-ui/components/AppBar'
import IcArrowLeft from '@interco/icons/core/action-navigation/ic_arrow_left'
import { Text } from '@interco/inter-toranja'
import { TextSize, TextType } from '@interco/inter-toranja/dist/components/Atoms/Text/types'

interface HeaderProps {
  title?: string
  isDarkMode: boolean
  isToranja?: boolean
  onClick: () => void
}

export const Header = ({ title = '', isDarkMode, isToranja = true, onClick }: HeaderProps) => {
  const getLeftIconColor = () => {
    if (isToranja) {
      return isDarkMode ? '#FFFFFF' : '#1E1A19'
    }
    return 'var(--primary500)'
  }

  return (
    <div style={{ '--app-bar-container-padding': '8px 24px' } as CSSProperties}>
      <AppBar
        leftIcon={
          <IcArrowLeft width={26} height={26} color={getLeftIconColor()} onClick={onClick} />
        }
      >
        <Text textSize={TextSize.Small} textType={TextType.Title} as="h1">
          {title}
        </Text>
      </AppBar>
    </div>
  )
}
